export default __webpack_public_path__ + "static/media/button.395571ac.png";